// extracted by mini-css-extract-plugin
module.exports = {"leftArrow":"TableFooter_leftArrow__cdPnO","rightArrow":"TableFooter_rightArrow__FcL0M","GridFooterContainerRoot":"TableFooter_GridFooterContainerRoot__qNDZn"};